import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v2/quotations/" });

export const QuotationService = {
  getQuotations: (pageSize, pageNumber, searchText) => {
    return api.get(`?pageSize=${pageSize}&pageNumber=${pageNumber}&searchText=${searchText}`);
  },

  getQuotation: (id) => {
    return api.get(id);
  },

  createQuotation: (payload) => {
    return api.post("", payload);
  },

  updateQuotation: (id, payload) => {
    return api.put(`${id}`, payload);
  },

  deleteQuotation: (id) => {
    return api.delete(`${id}`);
  },
};
